import { Box, Typography } from "@mui/material";
import React, { useContext, useEffect } from "react";
import AppLogo from "../../assets/images/company-logo-png.png";
// import { Helmet } from "react-helmet";

function Maintenance() {
  return (
    <>
      {/* <div>
        <Helmet>
          <title>Maintenance</title>
        </Helmet>
      </div> */}
      <div
        style={{
          height: "100vh",
          background: "#008374",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            padding: { xs: "20px 10px", md: "20px 20rem" },
          }}
        >
          <div>
            <img src={AppLogo} width={"160px"} />
          </div>
          <Typography variant="h3" color={"#ffffff"}>
            We'll be back soon!
          </Typography>
          <Typography
            variant="body1"
            color={"#ffffff"}
            style={{ marginTop: "10px" }}
          >
            Sorry for the inconvenience. We’re performing some maintenance at
            the moment. If you need to you can contact us on
            <a
              href="https://api.whatsapp.com/send?phone=923342989198"
              // href="https://api.whatsapp.com/send?phone=03432535307"
              target="_blank"
              style={{
                color: "#000",
                margin: "0 5px",
                cursor: "pointer",
              }}
            >
              whatsapp
            </a>
            for updates, otherwise we’ll be back up shortly!
          </Typography>
          <Typography
            variant={"h6"}
            color={"#ffffff"}
            style={{ marginTop: "20px", textDecoration: "underline" }}
          >
            The SIRL DIGITAL Team
          </Typography>
        </Box>
      </div>
    </>
  );
}

export default Maintenance;
